<template>
    <div
        class="d-flex align-items-center justify-content-center"
    >
        <div>
            <h1 class="text-center mb-4">
                Login
            </h1>

            <p
                v-if="$route.query.code"
                class="mb-5"
            >
                Please login to complete your account confirmation.
            </p>

            <div class="login-form">
                <div>
                    <form @submit.prevent="submitLogin">
                        <div class="field-wrap">
                            <label
                                for="email"
                            >
                                Email
                            </label>
                            <div class="field-wrap__input">
                                <input
                                    id="email"
                                    v-model="email"
                                    v-validate="{ required: true, email: true }"
                                    :class="{ 'border-error': errors.has('email') }"
                                    type="email"
                                    name="email"
                                    placeholder=""
                                >
                            </div>
                            <div
                                v-if="errors.has('email')"
                                class="py-3"
                            >
                                <div class="d-inline-block alert-error p-3 rounded-corners">
                                    {{ errors.first('email') }}
                                </div>
                            </div>
                        </div>

                        <div class="field-wrap">
                            <label
                                for="password"
                            >
                                Password
                            </label>
                            <div class="field-wrap__input">
                                <input
                                    id="password"
                                    v-model="password"
                                    v-validate="{ required: true }"
                                    :class="{ 'border-error': errors.has('password') }"
                                    type="password"
                                    name="password"
                                    placeholder=""
                                >
                            </div>
                            <div
                                v-if="errors.has('password')"
                                class="py-3"
                            >
                                <div class="d-inline-block alert-error p-3 rounded-corners">
                                    {{ errors.first('password') }}
                                </div>
                            </div>
                        </div>

                        <MButton
                            :disabled="processing"
                            :processing="processing"
                            type="submit"
                            class="btn btn--secondary btn-block w-100 mb-3"
                            spinner-variant="white"
                        >
                            Login
                        </MButton>
                        <a
                            href="/api/login/facebook"
                            class="btn btn--facebook d-flex align-items-center justify-content-center w-100"
                        >
                            <SVGSprite
                                class="facebook-icon mx-3"
                                name="facebook"
                            />
                            <span>
                                Login with Facebook
                            </span>
                        </a>
                        <p class="mt-5 mb-0 text-center">
                            Forgotten your password?
                        </p>
                        <p class="text-center mb-4">
                            <router-link :to="{ name: 'password-reset' }">
                                Request a reset here
                            </router-link>
                        </p>
                        <p class="mb-0 text-center">
                            <strong>Don't have an account?</strong>
                        </p>
                        <p class="mb-3 text-center">
                            <router-link :to="{ name: 'register' }">
                                Register here
                            </router-link>
                        </p>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    data() {
        return {
            loaded: false,
            email: '',
            password: '',
            processing: false,
            error: '',
            submittedEmail: ''
        };
    },
    computed: {
        ...mapGetters('user', [
            'authenticated'
        ])
    },
    watch: {
        authenticated() {
            if (this.authenticated) {
                this.$router.push(this.$route.query.redirect || { name: 'dashboard' });
            }
            else {
                this.loaded = true;
            }
        }
    },
    mounted() {
        if (this.$route.query.fblogin === 'failed') {
            this.$toasted.error('An error occured while attempting to log you in using Facebook');
        }
        else if (this.$route.query.fblogin === 'noemail') {
            this.$toasted.error('Your Facebook account needs to be associated with an email address');
        }
    },
    methods: {
        ...mapActions('user', [
            'login',
            'logout',
            'resendConfirmationEmail'
        ]),
        submitLogin() {
            this.$validator.validateAll()
                .then((result) => {
                    if (result) {
                        this.processing = true;
                        this.error = '';
                        this.submittedEmail = this.email;
                        this.login({
                            email: this.email,
                            password: this.password,
                            redirect: this.$route.query.redirect || false,
                            confirm_code: this.$route.query.code || false
                        })
                            .then((response) => {
                                if (response) {
                                    if (response.status !== 200) {
                                        this.$toasted.error(response.data.message, {
                                            duration: 7000,
                                            action: response.data.errorCode === 'not_confirmed' ? {
                                                text: 'Resend Validation Email',
                                                onClick: () => {
                                                    this.resendConfirmationEmail({ email: this.submittedEmail })
                                                        .then(() => {
                                                            this.$toasted.success('The validation email has been resent.');
                                                        })
                                                        .catch(() => {
                                                            this.$toasted.error('Unable to resend validation email. Please try again later or contact us if the error persists.');
                                                        });
                                                },
                                                class: 'd-inline-block btn btn--secondary text-white ml-4'
                                            } : null
                                        });
                                        this.processing = false;
                                    }
                                    else {
                                        this.username = '';
                                        this.password = '';
                                    }
                                }
                                else {
                                    this.$toasted.error('An unknown error occured while attempting to log you in. Please try again later or contact us if this persists.');
                                }
                            });
                    }
                });
        }
    }
};
</script>

<style lang="scss">
.login-form {
    max-width: 100%;
    padding: 0 3rem;

    input[type=email],
    input[type=password] {
        width: 100%;
    }

    @include media-breakpoint-up(sm) {
        width: 35rem;
    }
}

.page-login {
    .content {
        max-width: 100%;
    }

    .btn--facebook {
        background-color: #3C5A99;
    }

    .facebook-icon {
        width: 2rem;
    }
}
</style>
